/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import ContentWrapper from "ui/common/ContentWrapper";
import Header1 from "ui/kit/typography/Header1";
import Body from "ui/kit/typography/Body";
import GoogleSignInButton from "ui/feature/login/GoogleSignInButton";
import styles from "./Login.module.scss";
import FacebookSignInButton from "ui/feature/login/FacebookSignInButton";

const Login: React.FC = () => {
    return (
        <ContentWrapper>
            <Header1>Login</Header1>
            <Body className={styles.body}>Select one of the options below to login.</Body>
            <div className={styles.loginButtons}>
                <FacebookSignInButton/>
                <GoogleSignInButton/>
            </div>
        </ContentWrapper>
    )
}

export default Login;
